import { call, put, takeLatest, cancelled } from "redux-saga/effects";
import { fetchInactiveCeaDetails } from "../../service/fetchInactiveCeaDetails";
import {
  downloadInactiveCeaSuccess,
  downloadInactiveCeaFailure,
} from "../reducers/drmInactiveCeaSlice";

function* fetchAllPages({ reqBody, pageSize, controller }) {
  const firstResponse = yield call(fetchInactiveCeaDetails, {
    pageNum: 1,
    pageSize,
    requestBody: reqBody,
    controller,
  });

  const firstDetails = firstResponse?.details || {};
  const totalPages = firstDetails.totalPages ?? 1;
  const rows = Array.isArray(firstDetails.data) ? [...firstDetails.data] : [];

  for (let page = 2; page <= totalPages; page += 1) {
    const response = yield call(fetchInactiveCeaDetails, {
      pageNum: page,
      pageSize,
      requestBody: reqBody,
      controller,
    });
    const data = response?.details?.data;
    if (Array.isArray(data)) {
      rows.push(...data);
    }
  }

  return rows;
}

export function* workerDownloadBothInactiveCea({ payload }) {
  const controller = new AbortController();
  try {
    const { filters = {}, pageSize = 1000 } = payload || {};

    const bidRows = yield call(fetchAllPages, {
      reqBody: { fileType: 1, filters },
      pageSize,
      controller,
    });

    const dailyRows = yield call(fetchAllPages, {
      reqBody: { fileType: 2, filters },
      pageSize,
      controller,
    });

    const allRows = [...bidRows, ...dailyRows];

    yield put(
      downloadInactiveCeaSuccess({
        rows: allRows,
        message: "Inactive lane constraints processed successfully",
      })
    );
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to download inactive CEA details";
    yield put(downloadInactiveCeaFailure(message));
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}

function* drmInactiveCeaSaga() {
  yield takeLatest(
    "drmInactiveCea/downloadInactiveCeaStart",
    workerDownloadBothInactiveCea
  );
}

export default drmInactiveCeaSaga;
